import { Box, Container, Grid, Stack, Typography } from '@mui/material'
import React, { useCallback, useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../hooks/useLocalStorage'
import { resetStatusState } from '../../slices/statusSlice'
import { customStyles } from '../../styles'
import { animations } from '../../utils/animations'
import { CustomAlert } from '../helpers/alert/CustomAlert'

export const MainContainer = ({ children, sx, text, spacing, animation}) => {

   const dispatch = useDispatch()
   const { success, error, successMessage, errorMessage } = useSelector(state => state.status)
   const { fadeIn, fadeTop } = animations
   const { alert } = useSelector(state => state.status)
   const memoScroll = useCallback(() => {
      return window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      
   }, [ children ])

   useEffect(() => {
      memoScroll()
    }, [  ]);
  return (
   <Grid container sx={{
      // backgroundColor: customStyles.colors.backgroundColor,
      width: '100%',
      overflowY: 'smooth',
      overflow: 'hidden',
      ...sx
   }}>
      {
         alert && <CustomAlert />
      }
      <Grid item xs={12} p={2} mb={15} className={animation ? animation : fadeIn} 
      sx={{ animationDelay: '.4s', ...sx }}
      >
         { children }
      </Grid>
   </Grid>
  )
}
